import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

export const StyledCard = styled(Card)(({ theme }) => ({
    maxWidth: theme.breakpoints.values.lg, // Equivalent to max-w-4xl (assuming default MUI breakpoints)
    margin: 'auto',
    overflow: 'visible',
    minWidth: '1100px',
    marginTop: '30px',
}));

export const StyledCardContent = styled(CardContent)(({ theme }) => ({
    padding: theme.spacing(3), // Equivalent to p-6 (assuming theme spacing unit is 8px, 3*8=24px)
    // MUI CardContent has default padding, ensure it matches or override if needed
    '&:last-child': { // MUI adds padding-bottom to the last child CardContent, override if needed
        paddingBottom: theme.spacing(3),
    }
}));

export const StyledTitle = styled('h1')(({ theme }) => ({
    fontSize: '1.875rem', // text-3xl
    fontWeight: 'bold', // font-bold
    color: theme.palette.text.primary, // text-gray-900 - Adjust if your theme's primary text color differs
    marginBottom: theme.spacing(3), // mb-6
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.light})`, // from-primary to-primary/70 - Adjust colors/opacity as needed
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    textFillColor: 'transparent',
}));
